import type { FC } from "react";
import React from "react";
import { Body, Box, Heading } from "@edreamsodigeo/prisma-design-system";

import PrimeLogo from "~/components/common/PrimeLogo";
import type { WaitingMessageProps, WaitingMessageStyleProps } from "./contract";
import {
  PRIME_LOGO_SHORT_TEST_ID,
  PRIME_LOGO_TEST_ID,
  WAITING_MESSAGE_TEST_ID,
} from "./contract";

const DESKTOP_STYLE: WaitingMessageStyleProps = {
  logo: {
    margin: "3x_big",
    dataTestId: PRIME_LOGO_TEST_ID,
    type: "long",
  },
  title: {
    margin: "big",
  },
  description: {
    padding: "2x_huge",
  },
};

const MOBILE_STYLE: WaitingMessageStyleProps = {
  logo: {
    margin: "big",
    dataTestId: PRIME_LOGO_SHORT_TEST_ID,
    type: "short",
  },
  title: {
    margin: "base",
  },
  description: {
    padding: "small",
  },
};

const WaitingMessage: FC<WaitingMessageProps> = ({
  translatedTitle,
  translatedDescription,
  showLogo = true,
  isMobile = false,
}) => {
  const style = isMobile ? MOBILE_STYLE : DESKTOP_STYLE;

  return (
    <Box sx={{ textAlign: "center" }} data-testid={WAITING_MESSAGE_TEST_ID}>
      {showLogo && (
        <Box mb={style.logo.margin} data-testid={style.logo.dataTestId}>
          <PrimeLogo negative={false} size={"l"} type={style.logo.type} />
        </Box>
      )}

      {translatedTitle && (
        <Box my={style.title.margin}>
          <Heading type={"2"} weight={"medium"}>
            {translatedTitle}
          </Heading>
        </Box>
      )}

      <Box mb={"big"} flexDirection={"row"} px={style.description.padding}>
        <Body type={"base"} weight={"normal"}>
          {translatedDescription}
        </Body>
      </Box>
    </Box>
  );
};

export default WaitingMessage;
